var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.717 3.655a1.5 1.5 0 0 1 2.566 0l9.726 16.069A1.5 1.5 0 0 1 21.726 22H2.274a1.5 1.5 0 0 1-1.283-2.276zm1.71.518a.5.5 0 0 0-.855 0L1.847 20.24a.5.5 0 0 0 .427.76h19.452a.5.5 0 0 0 .428-.76zM12 8.5a.5.5 0 0 1 .5.5v5.5a.5.5 0 1 1-1 0V9a.5.5 0 0 1 .5-.5m.5 9a.5.5 0 1 0-1 0v1a.5.5 0 0 0 1 0z",
    clipRule: "evenodd"
  })));
});
const SvgAlert = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC43MTY5IDMuNjU0OTRDMTEuMzAwNiAyLjY5MDU0IDEyLjY5OTcgMi42OTA1NCAxMy4yODM0IDMuNjU0OTRMMjMuMDA5MiAxOS43MjM3QzIzLjYxNDMgMjAuNzIzNCAyMi44OTQ1IDIyLjAwMDQgMjEuNzI2IDIyLjAwMDRIMi4yNzQzMUMxLjEwNTc4IDIyLjAwMDQgMC4zODU5ODkgMjAuNzIzNCAwLjk5MTA1NyAxOS43MjM3TDEwLjcxNjkgMy42NTQ5NFpNMTIuNDI3OSA0LjE3Mjc0QzEyLjIzMzMgMy44NTEyNyAxMS43NjcgMy44NTEyNyAxMS41NzI0IDQuMTcyNzRMMS44NDY1NiAyMC4yNDE1QzEuNjQ0ODcgMjAuNTc0NyAxLjg4NDggMjEuMDAwNCAyLjI3NDMxIDIxLjAwMDRIMjEuNzI2QzIyLjExNTUgMjEuMDAwNCAyMi4zNTU0IDIwLjU3NDcgMjIuMTUzNyAyMC4yNDE1TDEyLjQyNzkgNC4xNzI3NFpNMTIuMDAwMSA4LjUwMDRDMTIuMjc2MyA4LjUwMDQgMTIuNTAwMSA4LjcyNDI2IDEyLjUwMDEgOS4wMDA0VjE0LjUwMDRDMTIuNTAwMSAxNC43NzY1IDEyLjI3NjMgMTUuMDAwNCAxMi4wMDAxIDE1LjAwMDRDMTEuNzI0IDE1LjAwMDQgMTEuNTAwMSAxNC43NzY1IDExLjUwMDEgMTQuNTAwNFY5LjAwMDRDMTEuNTAwMSA4LjcyNDI2IDExLjcyNCA4LjUwMDQgMTIuMDAwMSA4LjUwMDRaTTEyLjUwMDEgMTcuNTAwNEMxMi41MDAxIDE3LjIyNDMgMTIuMjc2MyAxNy4wMDA0IDEyLjAwMDEgMTcuMDAwNEMxMS43MjQgMTcuMDAwNCAxMS41MDAxIDE3LjIyNDMgMTEuNTAwMSAxNy41MDA0VjE4LjUwMDRDMTEuNTAwMSAxOC43NzY1IDExLjcyNCAxOS4wMDA0IDEyLjAwMDEgMTkuMDAwNEMxMi4yNzYzIDE5LjAwMDQgMTIuNTAwMSAxOC43NzY1IDEyLjUwMDEgMTguNTAwNFYxNy41MDA0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";